// AJAX sepete ekleme işlemi - Shopify Teması için Özel Çözüm
document.addEventListener('DOMContentLoaded', function() {
  console.log("AJAX Cart script yüklendi ve çalışıyor");
  
  // Sayfa yüklendiğinde mevcut sepet durumunu kontrol et
  fetchCartAndUpdateUI();
  
  // Sepete ekleme işlemi devam ediyor mu kontrolü için flag
  let addToCartInProgress = false;
  
  // EComposer'ın varsayılan sepet davranışını devre dışı bırak
  window.addEventListener('hashchange', function(event) {
    if (window.location.hash === '#ec-added-cart') {
      // Hash'i temizle ve sayfa yenilenmesini engelle
      history.pushState("", document.title, window.location.pathname + window.location.search);
      event.preventDefault();
      event.stopPropagation();
      return false;
    }
  });
  
  // Tüm "Add to Cart" formlarını yakala
  const addToCartForms = document.querySelectorAll('form[action="/cart/add"]');
  addToCartForms.forEach(form => {
    form.addEventListener('submit', function(event) {
      // Formun varsayılan davranışını engelle
      event.preventDefault();
      event.stopPropagation();
      
      if (addToCartInProgress) {
        console.log("Sepete ekleme işlemi devam ediyor, lütfen bekleyin...");
        return false;
      }
      
      // İşlem başladığında flag'i true yap
      addToCartInProgress = true;
      
      // Submit butonunu bul
      const submitButton = form.querySelector('button[type="submit"], input[type="submit"]');
      if (submitButton) {
        updateButtonState(submitButton, 'loading');
      }
      
      // Form verilerini al
      const formData = new FormData(form);
      const formDataObj = {};
      
      // FormData'yı bir objeye dönüştür
      for (let [key, value] of formData.entries()) {
        formDataObj[key] = value;
      }
      
      // Varyant ID ve miktarı al
      const variantId = formDataObj.id;
      const quantity = formDataObj.quantity || 1;
      
      if (!variantId) {
        console.error("Variant ID bulunamadı!");
        if (submitButton) {
          updateButtonState(submitButton, 'error');
        }
        addToCartInProgress = false;
        return false;
      }
      
      // Sepete ekle
      addToCartAjax(variantId, quantity, submitButton);
      
      return false;
    });
  });
  
  // Tüm "Add to Cart" butonlarını ve formları izle
  document.addEventListener('click', function(event) {
    // Tıklanan öğeyi veya üst öğelerinden birini bul
    const addToCartButton = event.target.closest('button[type="submit"][name="add"], .ecom-product-single__add-to-cart--submit, .ecom-collection__product-submit, .ecom-ajax-cart-submit, .ecom-collection__product-simple-add-to-cart, .ecom-ajax-cart-simple, a[href*="/cart/add"]');
    
    if (addToCartButton) {
      // Tıklama olayını engelle
      event.preventDefault();
      event.stopPropagation();
      
      if (addToCartInProgress) {
        console.log("Sepete ekleme işlemi devam ediyor, lütfen bekleyin...");
        return false;
      }
      
      // İşlem başladığında flag'i true yap
      addToCartInProgress = true;
      
      console.log("Add to Cart butonuna tıklandı, AJAX isteği gönderiliyor...");
      
      // Buton durumunu güncelle
      updateButtonState(addToCartButton, 'loading');
      
      // Varyant ID'sini ve miktarı al
      let variantId, quantity = 1;
      
      // Eğer bu bir link ise, URL'den varyant ID'sini çıkar
      if (addToCartButton.tagName === 'A' && addToCartButton.href && addToCartButton.href.includes('/cart/add')) {
        try {
          const url = new URL(addToCartButton.href, window.location.origin);
          variantId = url.searchParams.get('id');
          quantity = url.searchParams.get('quantity') || 1;
          console.log(`Link butonundan veri çıkarıldı: ID=${variantId}, Miktar=${quantity}`);
        } catch (error) {
          console.error("Link işlenirken hata oluştu:", error);
          updateButtonState(addToCartButton, 'error');
          addToCartInProgress = false;
          return false;
        }
      } else {
        // Form varsa, form verilerini kullan
        const form = addToCartButton.closest('form[action="/cart/add"]');
        
        if (form) {
          // Form verilerini al
          const formData = new FormData(form);
          const formDataObj = {};
          
          // FormData'yı bir objeye dönüştür
          for (let [key, value] of formData.entries()) {
            formDataObj[key] = value;
          }
          
          variantId = formDataObj.id;
          quantity = formDataObj.quantity || 1;
          console.log(`Form verilerinden çıkarıldı: ID=${variantId}, Miktar=${quantity}`);
        } else {
          // Form yoksa, butondan veri topla
          variantId = addToCartButton.dataset.variantId || 
                      addToCartButton.getAttribute('data-variant-id') || 
                      addToCartButton.getAttribute('data-id');
          
          // Yakındaki quantity input'u ara
          const quantityInput = document.querySelector('input[name="quantity"]');
          if (quantityInput) {
            quantity = quantityInput.value;
          }
          
          console.log(`Butondan veri çıkarıldı: ID=${variantId}, Miktar=${quantity}`);
        }
      }
      
      // Varyant ID yoksa, işlemi durdur
      if (!variantId) {
        console.error("Variant ID bulunamadı!");
        updateButtonState(addToCartButton, 'error');
        addToCartInProgress = false;
        return false;
      }
      
      // Sepete ekle
      addToCartAjax(variantId, quantity, addToCartButton);
      
      return false;
    }
  }, true); // Capturing phase'de çalıştır
  
  // Sepete AJAX ile ürün ekleme
  function addToCartAjax(variantId, quantity, button) {
    // Shopify AJAX API'sini kullan
    const data = {
      id: variantId,
      quantity: quantity
    };
    
    // AJAX isteği gönder
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify(data)
    })
    .then(response => {
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      return response.json();
    })
    .then(data => {
      console.log("Ürün başarıyla sepete eklendi:", data);
      if (button) {
        updateButtonState(button, 'success');
      }
      
      // Ürün sepete eklendikten sonra, doğrudan sepet verilerini al ve çekmece sepeti güncelle
      return fetch('/cart.js')
        .then(response => response.json())
        .then(cart => {
          console.log("Sepet verileri alındı, çekmece sepet güncelleniyor:", cart);
          
          // Sepet sayacını güncelle
          updateCartCountElements(cart);
          
          // Sepet çekmecesini tamamen yeniden oluştur
          rebuildMiniCart(cart);
          
          // Sepet çekmecesini aç
          tryOpenCartDrawer();
          
          // İşlem tamamlandığında flag'i false yap
          setTimeout(() => {
            addToCartInProgress = false;
          }, 500);
          
          return cart;
        });
    })
    .catch(error => {
      console.error("Sepete eklenirken hata oluştu:", error);
      if (button) {
        updateButtonState(button, 'error');
      }
      
      // Hata durumunda da flag'i false yap
      setTimeout(() => {
        addToCartInProgress = false;
      }, 500); // 0.5 saniye bekle, art arda tıklamaları önle
    });
  }
  
  // Buton durumunu güncelleme
  function updateButtonState(button, state) {
    if (!button) return;
    
    // Buton metni için farklı elementleri kontrol et
    const buttonText = button.querySelector('.ecom-add-to-cart-text') || 
                       button.querySelector('.ecom-collection__product-add-cart-text');
    
    if (!buttonText) {
      // Metin elementi bulunamadıysa ve buton bir link ise, içeriğini değiştir
      if (button.tagName === 'A' && !button.querySelector('*')) {
        const originalText = button.getAttribute('data-original-text') || button.textContent.trim();
        
        if (state === 'loading') {
          // Orijinal metni kaydet (eğer daha önce kaydedilmediyse)
          if (!button.getAttribute('data-original-text')) {
            button.setAttribute('data-original-text', originalText);
          }
          button.textContent = 'Adding to cart...';
        } else if (state === 'success') {
          button.textContent = 'Added to cart';
          // Butonu aktif et ve 2 saniye sonra orijinal metne geri döndür
          button.removeAttribute('disabled');
          setTimeout(() => {
            button.textContent = button.getAttribute('data-original-text') || originalText;
          }, 2000);
        } else if (state === 'error') {
          button.textContent = 'Error';
          // Butonu aktif et ve 2 saniye sonra orijinal metne geri döndür
          button.removeAttribute('disabled');
          setTimeout(() => {
            button.textContent = button.getAttribute('data-original-text') || originalText;
          }, 2000);
        }
        
        return;
      }
      
      // Hiçbir metin elementi bulunamadıysa işlemi atla
      return;
    }
    
    // Orijinal metni al ve kaydet
    if (!button.hasAttribute('data-original-text') && state === 'loading') {
      const originalText = buttonText.innerHTML;
      button.setAttribute('data-original-text', originalText);
    }
    
    const originalText = button.getAttribute('data-original-text') || button.dataset.textAddCart || buttonText.innerHTML;
    const loadingText = 'Adding to cart...';
    const successText = button.dataset.messageAddedCart || 'Added to cart';
    const errorText = 'Error';
    
    switch (state) {
      case 'loading':
        button.setAttribute('disabled', 'disabled');
        buttonText.innerHTML = loadingText;
        break;
      case 'success':
        buttonText.innerHTML = successText;
        setTimeout(() => {
          button.removeAttribute('disabled');
          buttonText.innerHTML = originalText;
        }, 2000);
        break;
      case 'error':
        buttonText.innerHTML = errorText;
        setTimeout(() => {
          button.removeAttribute('disabled');
          buttonText.innerHTML = originalText;
        }, 2000);
        break;
    }
  }
  
  // Sepet bilgisini al ve UI'ı güncelle
  function fetchCartAndUpdateUI(openDrawer = false) {
    console.log("Sepet bilgisi alınıyor...");
    
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        console.log("Sepet verileri alındı:", cart);
        
        // Sepet sayacını güncelle
        updateCartCountElements(cart);
        
        // Sepet çekmecesini tamamen yeniden oluştur
        rebuildMiniCart(cart);
        
        // Sepet çekmecesini aç (eğer isteniyorsa)
        if (openDrawer) {
          tryOpenCartDrawer();
        }
        
        // Sepet çekmecesini her durumda güncelle (sepet boş olsa bile)
        const miniCartContainers = document.querySelectorAll('.mini-cart-content, .ecom-ajax-cart-items');
        if (miniCartContainers.length) {
          miniCartContainers.forEach(container => {
            // Sepet çekmecesini güncelle
            rebuildMiniCart(cart);
          });
        }
      })
      .catch(error => {
        console.error("Sepet verileri alınırken hata oluştu:", error);
      });
  }
  
  // Sepet sayaç elementlerini güncelle
  function updateCartCountElements(cart) {
    const itemCount = cart.item_count;
    
    // 1. Standart sepet sayaç elementlerini güncelle
    const cartCountElements = document.querySelectorAll('.cart-count-bubble span, .cart-count, .ecom-cart-count, .ecom-header__cart-count, .js-cart-count, .site-header__cart-indicator');
    if (cartCountElements.length) {
      cartCountElements.forEach(el => {
        el.textContent = itemCount;
      });
    }
    
    // 2. Sepet sayacı kabarcıklarını göster/gizle
    const cartCountBubbles = document.querySelectorAll('.cart-count-bubble');
    if (cartCountBubbles.length) {
      cartCountBubbles.forEach(bubble => {
        if (itemCount > 0) {
          bubble.style.display = 'flex';
        } else {
          bubble.style.display = 'none';
        }
      });
    }
    
    // 3. Sepet toplamını güncelle
    const cartTotalElements = document.querySelectorAll('.cart-total, .ecom-cart-total, .js-cart-total');
    if (cartTotalElements.length) {
      cartTotalElements.forEach(el => {
        if (window.EComposer && window.EComposer.formatMoney) {
          el.innerHTML = window.EComposer.formatMoney(cart.total_price);
        } else {
          el.innerHTML = formatMoney(cart.total_price);
        }
      });
    }
  }
  
  // Sepet çekmecesini açmayı dene
  function tryOpenCartDrawer() {
    // EComposer teması için özel açma fonksiyonu
    if (window.EComposer && typeof window.EComposer.openCartDrawer === 'function') {
      console.log("EComposer.openCartDrawer fonksiyonu çağrılıyor...");
      window.EComposer.openCartDrawer();
      return;
    }

    // EComposer fonksiyonu yoksa, manuel olarak sepet çekmecesini aç
    const cartDrawers = document.querySelectorAll('.cart-drawer, .ecom-cart-drawer, .drawer--right, #CartDrawer, #cart-drawer, .mini-cart-content, .js-mini-cart, .ecom-ajax-cart, .ecom-popup');
    
    if (cartDrawers.length) {
      console.log("Sepet çekmecesi bulundu, açılıyor...");
      
      // Sepet çekmecesini aç
      cartDrawers.forEach(drawer => {
        // Drawer'ı görünür yap
        drawer.classList.add('active', 'open', 'is-active', 'is-open', 'drawer--is-open');
        drawer.style.display = 'block';
        drawer.style.zIndex = '9999';
        
        // Eğer drawer bir popup ise
        if (drawer.classList.contains('ecom-popup') || drawer.classList.contains('ecom-ajax-cart')) {
          // EComposer'ın popup açma fonksiyonunu çağırmayı dene
          if (window.EComposer && window.EComposer.Popup && typeof window.EComposer.Popup.open === 'function') {
            window.EComposer.Popup.open(drawer);
          }
        }
        
        // Çekmece içeriğini seç
        const cartContent = drawer.querySelector('.cart-drawer__content, .mini-cart-content');
        if (cartContent) {
          // Sepet çekmecesini güncelle
          rebuildMiniCart(cart);
        }
      });
      
      // Overlay'i göster
      const overlays = document.querySelectorAll('.overlaycart, .cart-drawer__overlay');
      if (overlays.length) {
        overlays.forEach(overlay => {
          overlay.classList.add('active');
        });
      }
      
      // Body'e sınıf ekle ve kaydırmayı engelle
      document.body.classList.add('drawer-open');
      document.body.style.overflow = 'hidden';
      document.body.style.position = 'fixed';
      document.body.style.width = '100%';
      document.body.style.top = `-${window.scrollY}px`;
    } else {
      console.log("Sepet çekmecesi bulunamadı, sepet sayfasına yönlendiriliyor...");
      window.location.href = '/cart';
    }
    
    // EComposer Popup.open fonksiyonunu kullanmayı dene
    if (window.EComposer && window.EComposer.Popup && typeof window.EComposer.Popup.open === 'function') {
      console.log("EComposer.Popup.open fonksiyonu çağrılıyor...");
      window.EComposer.Popup.open('cart-drawer');
    }
  }

  // Sepet çekmecesini kapat
  function closeCartDrawer() {
    const cartDrawers = document.querySelectorAll('.cart-drawer, .ecom-cart-drawer, .drawer--right, #CartDrawer, #cart-drawer, .mini-cart-content, .js-mini-cart, .ecom-ajax-cart, .ecom-popup');
    
    cartDrawers.forEach(drawer => {
      drawer.classList.remove('active', 'open', 'is-active', 'is-open', 'drawer--is-open');
    });

    // Overlay'i gizle
    const overlays = document.querySelectorAll('.overlaycart, .cart-drawer__overlay');
    if (overlays.length) {
      overlays.forEach(overlay => {
        overlay.classList.remove('active');
      });
    }

    // Body'den sınıfı kaldır ve kaydırmayı geri aç
    document.body.classList.remove('drawer-open');
    const scrollY = document.body.style.top;
    document.body.style.overflow = '';
    document.body.style.position = '';
    document.body.style.width = '';
    document.body.style.top = '';
    window.scrollTo(0, parseInt(scrollY || '0') * -1);

    // EComposer Popup.close fonksiyonunu kullanmayı dene
    if (window.EComposer && window.EComposer.Popup && typeof window.EComposer.Popup.close === 'function') {
      window.EComposer.Popup.close('cart-drawer');
    }
  }
  
  // Sepet çekmecesini tamamen yeniden oluştur
  function rebuildMiniCart(cart) {
    // Mini-cart container'ı bul
    const miniCartContainers = document.querySelectorAll('.mini-cart-content, .cart-drawer__content');
    
    if (miniCartContainers.length) {
      console.log("Mini-cart container bulundu, tamamen yeniden oluşturuluyor...");
      
      miniCartContainers.forEach(miniCartContent => {
        // Sepet içeriği HTML'i
        let cartItemsHtml = '<div class="js-mini-cart-content" style="max-height: none; overflow: visible;">';
        
        // Ücretsiz kargo progress barı
        const freeShippingThreshold = 15000; // 150 dolar = 15000 cent
        const currentAmount = cart.total_price;
        const remainingAmount = Math.max(0, freeShippingThreshold - currentAmount);
        const progress = Math.min(100, (currentAmount / freeShippingThreshold) * 100);
        
        cartItemsHtml += `
          <div class="free-shipping-bar" style="padding: 15px; background: #f7f7f7; margin-bottom: 15px; border-radius: 8px;">
            <div class="free-shipping-text" style="margin-bottom: 8px; color: #333; font-size: 14px;">
              ${remainingAmount > 0 
                ? `Add <strong>$${(remainingAmount / 100).toFixed(2)}</strong> more to get <strong>FREE SHIPPING!</strong>`
                : '<strong>🎉 Congratulations! You get FREE SHIPPING!</strong>'}
            </div>
            <div class="progress-bar-container" style="background: #ddd; height: 8px; border-radius: 4px; overflow: hidden;">
              <div class="progress-bar" style="background: #4CAF50; height: 100%; width: ${progress}%; transition: width 0.3s ease;"></div>
            </div>
          </div>`;
        
        // Sepet boşsa
        if (cart.item_count === 0) {
          cartItemsHtml += '<div class="mini-cart-empty">Your cart is empty</div>';
        } else {
          // Sepet içeriğini mini-cart formatında oluştur
          // Sadece ilk 5 ürünü göster
          const maxVisibleItems = 5;
          const visibleItems = cart.items.slice(0, maxVisibleItems);
          const hiddenItemsCount = Math.max(0, cart.items.length - maxVisibleItems);
          
          visibleItems.forEach((item, index) => {
            // Ürün resmi
            let itemImage = item.image ? item.image : '//cdn.shopify.com/s/assets/no-image-2048-5e88c1b20e087fb7bbe9a3771824e743c244f437e4f8ba93bbf7b11b53f7824c.gif';
            // Resim URL'sini düzelt
            if (itemImage && !itemImage.includes('http')) {
              itemImage = `https:${itemImage}`;
            }
            
            // Fiyat formatı
            const itemPrice = window.EComposer && window.EComposer.formatMoney ? 
              window.EComposer.formatMoney(item.price) : 
              formatMoney(item.price);
            
            // Ürün HTML'i - Kullanıcının gönderdiği formata göre
            cartItemsHtml += `
              <div class="mini-cart-item">
                <a class="mini-cart-image" href="${item.url}">
                  <img src="${itemImage}">
                </a>
                <div class="mini-cart-meta">
                  <p><a href="${item.url}">${item.title}</a></p>
                  <span> ${itemPrice}</span>
                  <div class="mini-cart-quantity">
                    <button class="mini-cart-quantity-button mini-cart-quantity-minus" data-id="${item.id}" data-key="${item.key}">-</button>
                    <input 
                      class="mini-cart-quantity-input" 
                      type="number" 
                      value="${item.quantity}" 
                      min="1" 
                      data-id="${item.id}" 
                      data-key="${item.key}">
                    <button class="mini-cart-quantity-button mini-cart-quantity-plus" data-id="${item.id}" data-key="${item.key}">+</button>
                  </div>
                </div>
                <button class="btn js-remove-mini-cart" data-id="${item.id}">×</button>
              </div>
            `;
          });
          
          // 5'ten fazla ürün varsa, "more(+X)" göster
          if (hiddenItemsCount > 0) {
            cartItemsHtml += `
              <div class="mini-cart-more">
                <a href="/cart" class="mini-cart-more-link">
                  more (+${hiddenItemsCount})
                </a>
              </div>
            `;
          }
        }
        
        // Sepet içeriği HTML'ini kapat
        cartItemsHtml += '</div>';
        
        // Sepet notu HTML'i
        let cartNoteHtml = '';
        if (cart.item_count > 0) {
          // Mevcut sepet notunu al
          const existingNote = cart.note || '';
          
          cartNoteHtml = `
            <div class="mini-cart-note">
              <label for="CartSpecialInstructions" class="mini-cart-note-label">Add a note to your order:</label>
              <textarea id="CartSpecialInstructions" class="mini-cart-note-textarea" name="note" placeholder="Add a note to your order...">${existingNote}</textarea>
              <button type="button" class="btn btn-sm btn-primary js-save-cart-note">Save Note</button>
            </div>
          `;
        }
        
        // Sepet alt kısmı HTML'i
        const formattedTotal = window.EComposer && window.EComposer.formatMoney ? 
          window.EComposer.formatMoney(cart.total_price) : 
          formatMoney(cart.total_price);
        
        const cartBottomHtml = `
          <div class="js-cart-bottom" style="display: ${cart.item_count > 0 ? 'block' : 'none'};">
            ${cartNoteHtml}
            <div class="mini-cart-total font-family-1">
              Cart Total: <span class="js-cart-total">${formattedTotal}</span>
            </div>
            <div class="mini-cart-taxes">
              Taxes and shipping calculated at checkout
            </div>
            <div class="mini-cart-btns mt-4">
              <a class="btn gradient-theme js-cart-btn-checkout btn-theme w-100 ${cart.item_count === 0 ? 'disabled' : ''}" href="/checkout">Checkout</a>
              <a class="btn btn-link btn-sm js-cart-btn-cart" href="/cart">View Cart</a>
            </div>
          </div>
        `;
        
        // Mini-cart içeriğini tamamen değiştir
        miniCartContent.innerHTML = cartItemsHtml + cartBottomHtml;
        
        // Mini-cart CSS'i ekle
        const style = document.createElement('style');
        style.textContent = `
          .mini-cart-more {
            text-align: center;
            padding: 10px 0;
            border-top: 1px solid #eee;
            margin-top: 10px;
          }
          .mini-cart-more-link {
            color: #333;
            font-weight: bold;
            text-decoration: none;
          }
          .mini-cart-more-link:hover {
            text-decoration: underline;
          }
          .mini-cart-note {
            margin: 15px 0;
            padding: 10px;
            border: 1px solid #eee;
            border-radius: 4px;
            background-color: #f9f9f9;
          }
          .mini-cart-note-label {
            display: block;
            margin-bottom: 5px;
            font-weight: bold;
          }
          .mini-cart-note-textarea {
            width: 100%;
            min-height: 60px;
            padding: 8px;
            border: 1px solid #ddd;
            border-radius: 4px;
            margin-bottom: 8px;
            resize: vertical;
          }
          .js-save-cart-note {
            background-color: #4CAF50;
            color: white;
            border: none;
            padding: 5px 10px;
            border-radius: 4px;
            cursor: pointer;
          }
          .js-save-cart-note:hover {
            background-color: #45a049;
          }
          .mini-cart-quantity {
            display: flex;
            align-items: center;
            margin-top: 5px;
          }
          .mini-cart-quantity-button {
            width: 35px;
            height: 35px;
            border: none;
            border-radius: 50%;
            background-color: #4CAF50;
            color: white;
            cursor: pointer;
          }
          .mini-cart-quantity-button:hover {
            background-color: #45a049;
          }
          .mini-cart-quantity-input {
            width: 40px;
            height: 35px;
            border: 1px solid #ddd;
            border-radius: 4px;
            padding: 5px;
            margin: 0 5px;
            text-align: center;
          }
        `;
        
        // Stil zaten eklenmediyse ekle
        if (!document.querySelector('style[data-mini-cart-more-style]')) {
          style.setAttribute('data-mini-cart-more-style', 'true');
          document.head.appendChild(style);
        }
        
        // Mini-cart CSS'ini düzenle - scroll kaldır
        const miniCartContentDiv = miniCartContent.querySelector('.js-mini-cart-content');
        if (miniCartContentDiv) {
          // Scroll kaldır
          miniCartContentDiv.style.maxHeight = 'none';
          miniCartContentDiv.style.overflow = 'visible';
          
          // Silme butonlarına olay dinleyicileri ekle
          setupMiniCartRemoveButtons(miniCartContentDiv);
        }
        
        // Not kaydetme butonuna olay dinleyicisi ekle
        const saveNoteButton = miniCartContent.querySelector('.js-save-cart-note');
        if (saveNoteButton) {
          saveNoteButton.addEventListener('click', saveCartNote);
        }
        
        // Miktar butonlarına olay dinleyicileri ekle
        const quantityButtons = miniCartContent.querySelectorAll('.mini-cart-quantity-button');
        if (quantityButtons.length) {
          quantityButtons.forEach(button => {
            button.addEventListener('click', function(event) {
              event.preventDefault();
              const id = this.getAttribute('data-id');
              const key = this.getAttribute('data-key');
              const input = this.closest('.mini-cart-quantity').querySelector('.mini-cart-quantity-input');
              const currentQuantity = parseInt(input.value);
              let newQuantity;
              
              if (this.classList.contains('mini-cart-quantity-minus')) {
                newQuantity = Math.max(1, currentQuantity - 1);
              } else if (this.classList.contains('mini-cart-quantity-plus')) {
                newQuantity = currentQuantity + 1;
              }
              
              // Miktarı güncelle
              updateCartItemQuantityById(id, newQuantity);
            });
          });
        }
        
        // Miktar giriş alanına olay dinleyicisi ekle
        const quantityInputs = miniCartContent.querySelectorAll('.mini-cart-quantity-input');
        if (quantityInputs.length) {
          quantityInputs.forEach(input => {
            input.addEventListener('change', function(event) {
              event.preventDefault();
              const id = this.getAttribute('data-id');
              const key = this.getAttribute('data-key');
              const newQuantity = parseInt(this.value);
              
              // Miktarı güncelle
              updateCartItemQuantityById(id, newQuantity);
            });
          });
        }
      });
    }
  }
  
  // Mini-cart silme butonları için olay dinleyicileri
  function setupMiniCartRemoveButtons(container) {
    const removeButtons = container.querySelectorAll('.js-remove-mini-cart');
    removeButtons.forEach(button => {
      button.addEventListener('click', function(event) {
        event.preventDefault();
        const id = this.getAttribute('data-id');
        
        // Sepetten öğeyi kaldır
        updateCartItemQuantityById(id, 0);
      });
    });
  }
  
  // Sepet öğesinin miktarını id ile güncelle
  function updateCartItemQuantityById(id, quantity) {
    // Güncelleme işlemi devam ediyor mu kontrolü
    if (window.cartUpdateInProgress) {
      console.log("Sepet güncellemesi devam ediyor, lütfen bekleyin...");
      return;
    }
    
    window.cartUpdateInProgress = true;

    // Sepet güncelleme isteği
    fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        id: id,
        quantity: quantity
      })
    })
    .then(response => response.json())
    .then(cart => {
      console.log("Sepet başarıyla güncellendi:", cart);
      
      // Sepet sayacını güncelle
      updateCartCountElements(cart);
      
      // Mini-cart içeriğini güncelle
      rebuildMiniCart(cart);
      
      // Sepet boşsa ve çekmece açıksa kapat
      if (cart.item_count === 0) {
        const cartDrawer = document.querySelector('.cart-drawer.is-active');
        if (cartDrawer) {
          setTimeout(() => {
            closeCartDrawer();
          }, 500);
        }
      }
    })
    .catch(error => {
      console.error("Sepet güncellenirken hata oluştu:", error);
    })
    .finally(() => {
      // İşlem bittiğinde flag'i temizle
      setTimeout(() => {
        window.cartUpdateInProgress = false;
      }, 500);
    });
  }
  
  // Ürün notunu güncelle
  function updateCartItemNote(key, noteText, button) {
    // Yükleniyor durumunu göster
    const originalText = button.textContent;
    button.disabled = true;
    button.textContent = 'Saving...';

    fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        id: key,
        properties: {
          _note: noteText
        }
      })
    })
    .then(response => response.json())
    .then(cart => {
      console.log('Ürün notu güncellendi:', cart);
      
      // Başarı göstergesi olarak düğmenin stilini değiştir
      const originalBackground = button.style.backgroundColor;
      
      // Düğmeyi kısa süreliğine değiştir
      button.disabled = false;
      button.style.backgroundColor = '#4CAF50';
      button.textContent = 'Saved';
      
      // 2 saniye sonra düğmeyi eski haline getir
      setTimeout(() => {
        button.style.backgroundColor = originalBackground;
        button.textContent = originalText;
      }, 2000);
    })
    .catch(error => {
      console.error('Ürün notu güncellenirken hata oluştu:', error);
      
      // Hata durumunda düğmeyi eski haline getir
      button.disabled = false;
      button.textContent = originalText;
    });
  }
  
  // Sepet notunu kaydet
  function saveCartNote() {
    const noteTextarea = document.getElementById('CartSpecialInstructions');
    if (!noteTextarea) return;
    
    const note = noteTextarea.value;
    const saveButton = document.querySelector('.js-save-cart-note');
    
    // Yükleniyor durumunu göster
    const originalText = saveButton.textContent;
    saveButton.disabled = true;
    saveButton.textContent = 'Saving...';
    
    fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        note: note
      })
    })
    .then(response => response.json())
    .then(cart => {
      console.log('Sepet notu güncellendi:', cart);
      
      // Başarı göstergesi olarak düğmenin stilini değiştir
      const originalBackground = saveButton.style.backgroundColor;
      
      // Düğmeyi kısa süreliğine değiştir
      saveButton.disabled = false;
      saveButton.style.backgroundColor = '#4CAF50';
      saveButton.textContent = 'Saved';
      
      // 2 saniye sonra düğmeyi eski haline getir
      setTimeout(() => {
        saveButton.style.backgroundColor = originalBackground;
        saveButton.textContent = originalText;
      }, 2000);
    })
    .catch(error => {
      console.error('Sepet notu güncellenirken hata oluştu:', error);
      
      // Hata durumunda düğmeyi eski haline getir
      saveButton.disabled = false;
      saveButton.textContent = originalText;
    });
  }
  
  // Sepet başlatma
  function initializeCart() {
    // Sepet çekmecesi açma/kapama butonlarını bul
    const cartToggleButtons = document.querySelectorAll('.js-cart-toggle, .js-cart-drawer-toggle, [data-cart-toggle]');
    
    // Her butona tıklama olayı ekle
    cartToggleButtons.forEach(button => {
      button.addEventListener('click', function(event) {
        event.preventDefault();
        tryOpenCartDrawer();
      });
    });
    
    // Sayfa yüklendiğinde sepet verilerini al ve sepet çekmecesini güncelle
    fetchCartAndUpdateUI(false);
    
    // Sepet çekmecesini her sayfa yüklendiğinde güncelle
    document.addEventListener('DOMContentLoaded', function() {
      fetchCartAndUpdateUI(false);
    });
    
    // Sayfa yenilendiğinde sepet çekmecesini güncelle
    window.addEventListener('load', function() {
      fetchCartAndUpdateUI(false);
    });
  }
  
  // Sepet başlatma
  initializeCart();
  
  // Sepet güncelleme olaylarını dinle
  document.addEventListener('cart:updated', function(event) {
    console.log("Sepet güncellendi olayı alındı:", event.detail);
  });
  
  // Para formatı fonksiyonu (EComposer.formatMoney mevcut değilse kullanılır)
  function formatMoney(cents) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    
    const value = parseInt(cents || 0) / 100;
    const formatter = new Intl.NumberFormat('tr-TR', {
      style: 'currency',
      currency: 'TRY',
      minimumFractionDigits: 2
    });
    
    return formatter.format(value);
  }
});


// Hedef öğeyi seç
const targetElement = document.querySelector('.cardraw');

// Observer oluştur
const observer = new MutationObserver((mutationsList) => {
  for (const mutation of mutationsList) {
    if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
      const hasActive = targetElement.classList.contains('active');
      document.body.style.overflow = hasActive ? 'hidden' : '';
    }
  }
});

// Observer'ı başlat
if (targetElement) {
  observer.observe(targetElement, { attributes: true, attributeFilter: ['class'] });
}

